import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper,
    Avatar,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as Eye } from "../../../../assets/images/eye.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as LockIcon } from "../../../../assets/images/lock.svg";
import * as Util from "../../../../services/global.service";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useSelector, useDispatch } from "react-redux";
import { listJobData, listCycle } from "../../../../actions/admin";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const UserResetPassword = (props) => {
    let { mainItems } = props
    const [itemsProgress, setItemsProgress] = React.useState([]);
    const [mainItemsProgress, setMainItemsProgress] = React.useState([]);
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [opens, setOpens] = React.useState(false);
    const [searchProgress, setSearchValueProgress] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const anchorRef = React.useRef(null);
    const anchorRefs = React.useRef(null);
    const [active, setActive] = React.useState(true);
    const [notActive, setNotActive] = React.useState(false);
    const [role, setRole] = React.useState([]);
    const [checkrole, setCheckRole] = React.useState({});
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    useEffect(() => {
        dataSerachsProgress(mainItems)
    }, [mainItems])
    let checkAll = () => {
        let check = true
        let data = checkrole
        let getObjectKey = Object.keys(data)
        let checks = getObjectKey.filter((rs) => data[rs] === true)
        if (checks.length !== role.length) {
            check = false
        } else {
            check = true
        }
        return check;
    }
    let checkIndeterminate = () => {
        let check = true
        let data = checkrole
        let getObjectKey = Object.keys(data)
        let checksTrue = getObjectKey.filter((rs) => data[rs] === true)
        let checksFalse = getObjectKey.filter((rs) => data[rs] === false)
        if (getObjectKey.length !== checksTrue.length && getObjectKey.length !== checksFalse.length) {
            check = true
        } else {
            check = false
        }
        return check;
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const handleCloses = (event) => {
        if (anchorRefs.current && anchorRefs.current.contains(event.target)) {
            return;
        }

        setOpens(false);
    };
    const filterRole = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        let datas = JSON.parse(JSON.stringify(checkrole))
        let getObjectKey = Object.keys(datas)
        if (getObjectKey.length > 0) {
            for (let index = 0; index <= dataFilter.length - 1; index++) {
                if (datas[dataFilter[index]?.role] === true) {
                    result.push(dataFilter[index])
                }
            }
            filterActiveSerach(result)
        } else {
            filterActiveSerach(data)
        }
    };
    const filterActiveSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (notActive === false && active === false) {
            setItemsProgress(result)
        } else if (notActive === true && active === true) {
            setItemsProgress(data)
        } else {
            if (notActive === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "inactive");
                result = resultData
                setItemsProgress(result)
            } else if (active === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "active");
                result = resultData
                setItemsProgress(result)
            }
        }
    };

    const EditNotActive = (data) => {
        if (data === "notActive") {
            setNotActive(!notActive)
        } else if (data === "active") {
            setActive(!active)
        } else if (data === "selectAll") {
            if (notActive === true && active === true) {
                setNotActive(false)
                setActive(false)
            } else if (notActive === false && active === false) {
                setNotActive(true)
                setActive(true)
            } else if (notActive === true || active === true) {
                setNotActive(true)
                setActive(true)
            }
        }
    };
    const changeRole = (roleSelect) => {
        let data = JSON.parse(JSON.stringify(checkrole))
        if (roleSelect === "all") {
            let getObjectKey = Object.keys(data)
            let check = getObjectKey.filter((rs) => data[rs] === true)
            let sumData = {}
            if (check.length !== role.length) {
                for (let index = 0; index <= role.length - 1; index++) {
                    sumData[role[index]] = true
                }
            } else {
                for (let index = 0; index <= role.length - 1; index++) {
                    sumData[role[index]] = false
                }
            }
            setCheckRole(sumData)
        } else {
            data[roleSelect] = !checkrole[roleSelect]
            setCheckRole(data)
        }
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleToggles = () => {
        setOpens((prevOpen) => !prevOpen);
    };
    const handleSearchProgress = (event) => {
        setSearchValueProgress(event.target.value);
    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return itemsProgress
            .slice(firstPageIndex, lastPageIndex);
    }, [itemsProgress, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = itemsProgress
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [itemsProgress, perPage]);

    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);

    useEffect(() => {
        dataSerachsProgress()
    }, [searchProgress, notActive, active, checkrole]);

    const dataSerachsProgress = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data !== undefined && data !== null ? data : mainItems))
        if (searchProgress !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'fullname') {
                        return rs[key].toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'options') {
                        if (rs[key] !== undefined && rs[key] !== null && rs[key] !== "") {
                            return Object.keys(rs[key]).some(keys => {
                                return rs[key][keys].toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1;
                            });
                        }
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        // await filterRole(result);
        await filterActiveSerach(result);
    };

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            if (key === "updated_by") {
                currentData.sort(function (b, a) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "data_as_of" || key === "end_date" || key === "start_date") {
                currentData.sort(function (b, a) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "options") {
                currentData.sort(function (b, a) {
                    if (a[key].name_en > b[key].name_en) {
                        return -1;
                    }
                    if (b[key].name_en > a[key].name_en) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (b, a) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "updated_by") {
                currentData.sort(function (a, b) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "data_as_of" || key === "end_date" || key === "start_date") {
                currentData.sort(function (a, b) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "options") {
                currentData.sort(function (a, b) {
                    if (a[key].name_en > b[key].name_en) {
                        return -1;
                    }
                    if (b[key].name_en > a[key].name_en) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });

            }
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }


    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));

    return (
        <Box
            sx={{
                width: "100%"
            }}
        >
            <Grid container spacing={2}>
                <Grid container item >
                    <Box sx={{ width: "100%" }}>
                        <Box pb="30px" pt="30px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <TextField
                                id="input-with-icon-textfield"
                                fullWidth
                                placeholder={t('label.search')}
                                size="small"
                                sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                className="searchTextField-h40"
                                value={searchProgress}
                                onChange={handleSearchProgress}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search style={{ color: "#C4C4C4" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </Box>
                    <div className={classes.root}>
                        <Paper className={classes.flexPaper} >
                            <Box
                                px="40px"
                            >
                                <Box
                                    px="25px"
                                    py="19px"
                                    sx={{ display: "flex", "flex-direction": "row" }}
                                >
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.666% - 10.7142px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.empID')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(30.04% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.employeeName')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("fullname", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("fullname", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.666% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('security.totalRole')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("total_role", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("total_role", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('label.formStatus')}
                                        </Typography>
                                        <Stack direction="row" spacing={2}>
                                            <div>
                                                <FilterStatus
                                                    ref={anchorRef}
                                                    id="composition-button"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={handleToggle}
                                                />
                                                <Popper
                                                    open={open}
                                                    anchorEl={anchorRef.current}
                                                    role={undefined}
                                                    placement="bottom-start"
                                                    transition
                                                    disablePortal
                                                    style={{ "z-index": "1" }}
                                                >
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{
                                                                transformOrigin:
                                                                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                            }}
                                                        >
                                                            <Paper sx={{ "margin-top": "5px !important" }}>
                                                                <ClickAwayListener onClickAway={handleClose}>
                                                                    <MenuList
                                                                        autoFocusItem={open}
                                                                        id="composition-menu"
                                                                        aria-labelledby="composition-button"
                                                                        onKeyDown={handleListKeyDown}
                                                                    >

                                                                        <Box px="16px" py="6px">
                                                                            <FormGroup>
                                                                                <FormControlLabel control={<Checkbox indeterminate={notActive !== active} onChange={e => EditNotActive("selectAll")} checked={notActive === true && active === true ? true : false} />} label={t('competency.selectAll')} />
                                                                                <FormControlLabel control={<Checkbox onChange={e => EditNotActive("notActive")} checked={notActive} />} label={t('admin.label.inactive')} />
                                                                                <FormControlLabel control={<Checkbox onChange={e => EditNotActive("active")} checked={active} />} label={t('admin.label.active')} />
                                                                            </FormGroup>
                                                                        </Box>
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </div>
                                        </Stack>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.startDate')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("start_date", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("start_date", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.EndDate')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("end_date", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("end_date", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.updatedBy')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "75px" }}>
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                            {t('admin.label.action')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider width="100%" />
                            </Box>
                            {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                <Box px="40px">
                                    <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                        <Box
                                            sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                            px="25px"
                                        >
                                            <Box sx={{ width: "calc(11.666% - 10.7142px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="300px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.formatData(row?.code, "")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(30.04% - 10.7143px)", display: "flex", justifyContent: "flex-start", alignItems: "center" }} pr="15px">
                                                <Avatar
                                                    src={Util.formatData(row?.photo, "")}
                                                    sx={{
                                                        cursor: "pointer",
                                                        width: 40,
                                                        height: 40,
                                                    }}
                                                />
                                                <Box ml={(2)} sx={{ width: "calc(100% - 60px)"}}>
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        <Typography pb={row?.options?.name_th !== null && row?.options?.name_th !== undefined && row?.options?.name_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.options?.name_en !== undefined && row?.options?.name_en !== null ? Util.formatData(row?.options?.name_en, "") : Util.formatData(row?.fullname, "")}
                                                        </Typography>
                                                        {row?.is_lock ?
                                                            <LockIcon style={{ marginLeft: "8px" }}></LockIcon>
                                                            : null
                                                        }
                                                    </Box>
                                                    {row?.options?.name_th !== null && row?.options?.name_th !== undefined && row?.options?.name_th !== "" ?
                                                        <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.options?.name_th}
                                                        </Typography>
                                                        :
                                                        null
                                                    }
                                                </Box>
                                            </Box>
                                            <Box sx={{ width: "calc(11.666% - 10.7143px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.formatData(row?.total_role, "")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.status === "active" ? "ACTIVE" : "INACTIVE"}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.dateDayFormat(row?.start_date, "")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.dateDayFormat(row?.end_date)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(11.667% - 10.7143px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                </Typography>
                                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "75px", "justify-content": "center" }}>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "z-index": "1", "justify-content": "center" }}>
                                                    <Box>
                                                        <BootstrapTooltip title={t('label.edit')} placement="top">
                                                            <EditIcon style={{ cursor: "pointer" }} onClick={() => { clickLink(`/admin/security/reset-password/${row?.serial}`) }} />
                                                        </BootstrapTooltip>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Divider width="100%" />
                                </Box>
                            ))
                                :
                                <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                    <Nodata />
                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                        {t('label.noDataFilter')}
                                    </Typography>
                                    <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                        {t('label.tryChangingFilter')}
                                    </Typography>
                                </Box>
                            }
                        </Paper>
                    </div>
                </Grid>
            </Grid>
            <Grid container mt={1} spacing={2} >
                <Grid item xs sm md display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                    </Box>
                    <Select
                        id="pagination"
                        variant="outlined"
                        defaultValue={10}
                        value={perPage}
                        onChange={handlePerPageChange}
                        displayEmpty
                        size="small"
                        className="white-bg"
                    >
                        <MenuItem value={10}>
                            <Typography style={{ fontWeight: "300" }}>10</Typography>
                        </MenuItem>
                        <MenuItem value={20}>
                            <Typography style={{ fontWeight: "300" }}>20</Typography>
                        </MenuItem>
                        <MenuItem value={30}>
                            <Typography style={{ fontWeight: "300" }}>30</Typography>
                        </MenuItem>
                    </Select>
                </Grid>
                <Grid item display="flex" alignItems="center" ml="auto">
                    <Typography variant="s14_fw400">
                        {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                    </Typography>
                </Grid>
                <Grid item ml="auto" display="flex" alignItems="center">
                    <CustomPagination
                        setCurrentPage={handleSetCurrentPage}
                        selected={currentPage}
                        count={totalPage}
                    ></CustomPagination>
                </Grid>
            </Grid>
        </Box>
    );
};
export default UserResetPassword;
